import { useMemo } from 'react';
import { useListRecordsQuery } from '@platform/state/api';
import type { IRelatedItem } from './IRelatedItem';

/**
 * Значення полів зв'язаних записів типу `typeKey` для фільтра секції (зв'язок несе лише код, назву й статус): один запит списку
 * `code:in:…` (до 100). `pending` — значення ще читаються (до відповіді секція ці записи не показує); без фільтра запиту немає.
 */
export function useLinkedValues(ws: string, typeKey: string, items: readonly IRelatedItem[], enabled: boolean) {
  const codes = useMemo(() => [...new Set(items.filter((i) => i.recordType === typeKey && i.code > 0).map((i) => i.code))].sort((a, b) => a - b), [items, typeKey]);
  const skip = !enabled || !typeKey || !codes.length;
  const { data, isLoading } = useListRecordsQuery({ ws, rt: typeKey, params: { filter: `code:in:${codes.join(',')}`, pageSize: 100 } }, { skip });
  const values = useMemo(() => new Map((data?.items ?? []).map((r) => [r.id, { ...r.ext, ...r.values } as Readonly<Record<string, unknown>>])), [data]);
  return { values, pending: !skip && isLoading };
}
